import { render } from "./anc_tetanus_injections.vue?vue&type=template&id=40b9f523&scoped=true"
import script from "./anc_tetanus_injections.vue?vue&type=script&lang=js"
export * from "./anc_tetanus_injections.vue?vue&type=script&lang=js"

import "./anc_tetanus_injections.vue?vue&type=style&index=0&id=40b9f523&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b9f523"]])

export default __exports__